Auth = require 'app/scripts/db/auth'
AutoInsertionView = require 'app/scripts/views/internal/autocomplete/auto-insertion-view'
CompleterUtil = require 'app/scripts/views/internal/autocomplete/completer-util'
CheckItemMenuView = require 'app/scripts/views/checklist/check-item-menu-view'
Dates = require 'app/scripts/lib/dates'
{ dontUpsell } = require '@trello/config'
DueDateHelpers = require 'app/scripts/views/internal/due-date-helpers'
EditableView = require 'app/scripts/views/internal/editable-view'
{ featureFlagClient } = require '@trello/feature-flag-client'
{ forNamespace } = require 'app/common/lib/util/i18n'
getExperiment = require 'app/scripts/lib/experiments/simple-test'
moment = require 'moment'
{ OrganizationFeature } = require '@trello/product-features'
PopOver = require 'app/scripts/views/lib/pop-over'
TFM = require 'app/scripts/lib/markdown/tfm'
Util = require 'app/scripts/lib/util'
friendlyLinks = require 'app/scripts/views/internal/friendly-links'
{ mixin } = require 'app/scripts/lib/mixin_DO_NOT_USE'
{ track, trackUe, Verb, Noun } = require '@trello/analytics'
t = require('app/scripts/views/internal/teacup-with-helpers')('checklist_item')
{ toggleAssignPopoverV2 } = require 'app/scripts/views/checklist/toggle-assign-popover'
{ toggleDatePopoverV2 } = require 'app/scripts/views/checklist/toggle-date-popover'
{ toggleUpsellAdvancedChecklist } = require 'app/scripts/views/checklist/upsell-advanced-checklist'
{ toggleClearPopover } = require 'app/scripts/views/checklist/toggle-clear-popover'
urls = require 'app/scripts/controller/urls'
memberAvatarTemplate = require 'app/scripts/views/templates/member_avatar'
Layout = require 'app/scripts/views/lib/layout'
{ hasUpsell, hasAdvancedChecklists, shouldShowEditModeButtons } = require './has-advanced-checklists'
{ getKey, Key, registerShortcutHandler, Scope, unregisterShortcutHandler } = require '@trello/keybindings'

viewTitle = forNamespace('view title')

editAssignTemplate = t.renderable (fullName) ->
  t.icon 'add-member'
  if fullName
    t.text(fullName)
  else
    t.format('assign')

editDueTemplate = t.renderable (dueText) ->
  t.icon 'clock'
  if dueText
    t.text(dueText)
  else
    t.format('due-date')

template = t.renderable ({ editable, showAssignBadge, showDueDateBadge }) ->
  t.div '.checklist-item-checkbox', { class: t.classify({ enabled: editable, 'js-toggle-checklist-item': editable }) }, ->
    t.icon 'check', { class: 'checklist-item-checkbox-check' }

  t.div '.checklist-item-details.non-empty.js-checkitem', { class: t.classify({ editable }), attr: 'name' }, ->
    t.div '.checklist-item-row.js-checkitem-row.current', ->
      t.div '.checklist-item-text-and-controls.hide-on-edit', ->
        t.span '.checklist-item-details-text.markeddown.js-checkitem-name'
        t.div '.checklist-item-controls', ->
          if showDueDateBadge
            t.span '.checklist-item-due.js-checklist-item-due'
          if showAssignBadge
            t.span '.checklist-item-assignee.js-checklist-item-assignee'
          if editable
            t.div '.checklist-item-menu.js-open-menu', ->
              t.span '.icon-sm.icon-overflow-menu-horizontal'

      if editable
        t.div '.edit.check-item-options-menu', ->
          t.textarea '.field.full.single-line.js-checkitem-input', { type: 'text' }

    if editable
      t.p '.edits-warning.quiet', ->
        t.format 'you-have-unsaved-edits-on-this-field'
        t.text ' '
        t.a '.js-view-edits', { href: '#' }, ->
          t.format 'view-edits'
        t.text " - "
        t.a '.js-discard-edits', { href: '#' }, ->
          t.format 'discard'

assigneeTemplate = t.renderable ({ member }, canEdit, advancedChecklistsEnabled, showUpsell) ->
  if advancedChecklistsEnabled || member || showUpsell
    memberAvatar = ->
      t.div '.member.m-member-mod-24', { class: t.classify('long-initials': member.initials?.length > 2) }, ->
        memberAvatarTemplate(member)

    if canEdit
      showClear = member && !advancedChecklistsEnabled

      t.button '.subtle', {
        class: t.classify({
          'js-assign': !showClear
          'js-clear-assignment': showClear
        }),
      }, ->
        if member
          memberAvatar()
        else
          t.icon 'add-member'
    else if member
      t.span '.disabled', ->
        memberAvatar()

dueTemplate = t.renderable (due, className, canEdit, advancedChecklistsEnabled, showUpsell) ->
  if advancedChecklistsEnabled || due || showUpsell
    if canEdit
      showClear = due && !advancedChecklistsEnabled

      t.button ".subtle.#{ className }", {
        class: t.classify({
          'js-due': !showClear,
          'js-clear-due': showClear
        })
      }, ->
        t.icon 'clock'
        if due
          t.text due
    else if due
      t.span '.disabled', { class: className }, ->
        t.icon 'clock'
        t.text due

module.exports = mixin AutoInsertionView, CompleterUtil, class CheckItemView extends EditableView
  className: 'checklist-item'

  allowNewlines: false

  initialize: ->
    @listenTo @model,
      'change:name': ->
        @renderName()
        @renderAssignee()
        @renderDue()
      'change:state': ->
        @renderState()
        @renderDue()
      'change:due': ->
        @renderDue()
        @renderEditItemButtons()
      'change:idMember': ->
        @renderAssignee()
        @renderEditItemButtons()
    super

  events:
    'keyup .js-checkitem-input': 'keyAutoMention'
    'click .js-toggle-checklist-item': 'toggleState'

    'click .js-open-menu': 'openMenu'

    'click .js-open-mention-selector': 'commentMentionMember'
    'click .js-open-emoji-selector': 'commentAddEmoji'
    'movecheckitem': 'moveCheckItem'

    'mouseenter': ->
      if !@model.editable()
        return

      org = @model.getBoard()?.getOrganization()
      product = org?.getProduct()

      if !hasAdvancedChecklists(product)
        return

      registerShortcutHandler(@onShortcut, { scope: Scope.DialogSection, clearScope: true })

    'mouseleave': ->
      unregisterShortcutHandler(@onShortcut)

    # Advanced Checklists
    'click .js-assign:not([disabled])': (e) ->
      @assignUpsellOrPopover(e, {
        trackingMethod: 'by clicking member button in checkitem view'
      })

    'click .js-due:not([disabled])': (e) ->
      @dueDateUpsellOrPopover(e, {
        trackingMethod: 'by clicking due date badge in checkitem view'
      })

    'click .js-clear-assignment:not([disabled])': (e) ->
      toggleClearPopover({
        title: viewTitle('assign'),
        message: t.l('clear-assignment-message'),
        removeText: t.l('clear-assignment'),
        clear: => @_setMember(null)
        upsell: @_hasUpsell()
      })(e)

    'click .js-clear-due:not([disabled])': (e) ->
      toggleClearPopover({
        title: viewTitle('change due date'),
        message: t.l('clear-due-message'),
        removeText: t.l('clear-due'),
        clear: => @_setDue(null)
        upsell: @_hasUpsell()
      })(e)

  onShortcut: (event) =>
    key = getKey(event)

    switch key
      when Key.Space
        myId = Auth.myId()
        @_setMember(if @model.get('idMember') == myId then null else myId)
        track 'Keyboard Shortcuts', 'Space - Toggle Assigning Self', 'Check Item'
      when Key.a, Key.m
        @$('.js-assign').click()
        track 'Keyboard Shortcuts', 'A - Assign Members', 'Check Item'
      when Key.d
        @$('.js-due').click()
        track 'Keyboard Shortcuts', 'D - Due Dates', 'Check Item'
      else
        return

    event.preventDefault()
    return

  dueDateUpsellOrPopover: (e, { trackingMethod, billingUrl }) ->
    if hasAdvancedChecklists(@model.getBoard()?.getOrganization()?.getProduct())
      toggleDatePopoverV2({
        title: viewTitle('change due date'),
        setDate: (date) => @_setDue(date, 'by clicking a date in the due date picker')
        getInitialDate: => @model.get('due')
        trackingMethod,
      })(e)
    else if @_hasUpsell()
      toggleUpsellAdvancedChecklist({
        trackingMethod: 'by clicking due date button in checkitem composer',
        billingUrl: @getBillingUrl()
      })(e)

  assignUpsellOrPopover: (e, { trackingMethod }) ->
    card = @model.getCard()
    board = @model.getBoard()

    if hasAdvancedChecklists(@model.getBoard()?.getOrganization()?.getProduct())
      toggleAssignPopoverV2({
        title: viewTitle('assign'),
        getCardMembers: => card.memberList.filterDeactivated(force: true, model: board).toJSON()
        getBoardMembers: => board.memberList.filterDeactivated(force: true).toJSON()
        trackingMethod,
        getInitialMember: => @model.get('idMember'),
        setMember: (idMember) =>
          @_setMember(idMember)
      })(e)
    else if @_hasUpsell()
      toggleUpsellAdvancedChecklist({
        trackingMethod: 'by clicking member button in checkitem composer',
        billingUrl: @getBillingUrl()
      })(e)

  getCard: -> @model.getCard()

  getBillingUrl: ->
    org = @model.getBoard().getOrganization()
    if org?
      urls.getOrganizationBillingUrl(org)

  advancedCheckItemFromModel: ->
    return {
      name: @model.get('name'),
      validAssigneeUsernames: @model.getBoard().memberList.map((member) -> member.get('username'))
      orgProductNumber: @model.getBoard()?.getOrganization()?.getProduct()
    }

  render: ->
    view = @
    model = @model

    org = @model.getBoard()?.getOrganization()
    product = org?.getProduct()
    editable = @model.editable()

    _hasAdvancedChecklists = hasAdvancedChecklists(product)
    _hasUpsell = @_hasUpsell()

    @$el.html(
      template({
        showAssignBadge: _hasAdvancedChecklists || _hasUpsell || @model.get('idMember')?
        showDueDateBadge: _hasAdvancedChecklists || _hasUpsell || @model.get('due')?
        editable: editable
      })
    )

    @renderAssignee()
    @renderDue()
    @renderName()
    @renderState()
    @recallDrafts()

    @

  getTextInput: ->
    @$('.js-checkitem-input')

  getMentionTarget: ->
    @$('.js-open-mention-selector')[0]

  getEmojiTarget: ->
    @$('.js-open-emoji-selector')[0]

  _hasUpsell: ->
    board = @model.getBoard()
    orgIsHidden = board?.hasOrganization() && !board?.getOrganization()?
    hasUpsell(@model.editable(), !orgIsHidden)

  renderName: (e) ->
    name = @model.get('name')

    @$('.js-checkitem-row').data('unmarkeddown', name)

    nameHtml = TFM.checkItems.format(name, { textData: @model.get('nameData') }).output
    $name = @$('.js-checkitem-name')
    $name.empty().append(nameHtml)

    friendlyLinks $name[0], @model.getBoard()
    return

  renderAssignee: ->
    $assignee = @$('.js-checklist-item-assignee')
    if !$assignee.length
      return

    product = @model.getBoard()?.getOrganization()?.getProduct()

    _hasAdvancedChecklists = hasAdvancedChecklists(product)

    predicate =
      # If there is a member in model.get('idMember'), check for that
      if (idMember = @model.get('idMember'))?
        (member) -> member.id == idMember

    member =
      if predicate?
        @model.getBoard().memberList.find(predicate)

    $assignee.html(assigneeTemplate({
      member: member?.toJSON()
    }, @model.editable(), _hasAdvancedChecklists, @_hasUpsell()))
    .toggleClass('unset', !member?)

    @$el.toggleClass('no-assignee', !member?)

    return

  renderDue: ->
    $due = @$('.js-checklist-item-due')

    if !$due.length
      return

    product = @model.getBoard()?.getOrganization()?.getProduct()

    _hasAdvancedChecklists = hasAdvancedChecklists(product)

    due = @model.get('due')

    dueText = due && Dates.toDateString(due)

    className =
      if due
        complete = @model.get('state') == 'complete'
        DueDateHelpers.classForDueDate(moment(due).toDate(), complete)
      else
        ""

    $due.html(dueTemplate(dueText, className, @model.editable(), _hasAdvancedChecklists, @_hasUpsell()))
    .toggleClass('unset', !due)

    @$el.toggleClass('no-due', !due)

    return

  renderState: (e) ->
    data = @model.toJSON()
    data.checked = (data.state == 'complete')
    @$el.toggleClass('checklist-item-state-complete', data.checked)
    return

  toggleState: (e) ->
    return if !@model.editable()

    isComplete = @model.get('state') == 'complete'

    newState = if isComplete then 'incomplete' else 'complete'

    if newState == 'complete'
      @$el.addClass('checklist-item-fade-out')

      @setTimeout =>
        @model.update('state', newState)
        @$el.removeClass('checklist-item-fade-out')
      , 200

    else
      @$el.removeClass('checklist-item-fade-out')
      @model.update('state', newState)

    track("Checklist", "Toggle Checklist Item State", newState)

    return

  moveCheckItem: (e, ui, checklist, toDifferentChecklist) ->
    if !toDifferentChecklist && @model.getChecklist() != checklist
      # We've already handled this as a move to a different checklist
      return

    checkItems = ui.item.parent().children()
    index = checkItems.index(ui.item)
    pos = checklist.calcPos(index, @model)

    if toDifferentChecklist
      @model.update { pos, idChecklist: checklist.id }
      @model.collection.remove(@model)
      checklist.checkItemList.add(@model)
    else
      @model.update('pos', pos)

    checklist.checkItemList.sort({ silent: true })

    track("Checklist", "Reorder Checklist Item")

  commitEdits: (e) ->
    PopOver.hide()
    if @$('.js-checkitem-input').val().length == 0
      @model.destroy()
    else
      prevName = @model.get('name')
      super

  _setDue: (date, trackingMethod) ->
    prevDate = @model.get('due')

    @model.update('due', date)

    verb =
      if !prevDate && date
        'adds'
      else if !date && prevDate
        'removes'
      else
        'changes'
    trackUe('card detail', verb, 'due date', 'on checkitem', '', trackingMethod || 'by clicking a submit button in due date picker')

  _setMember: (idMember) ->
    prevMember = @model.get('idMember')

    @model.update('idMember', idMember)

    verb =
      if !prevMember && idMember
        'adds'
      else if !idMember && prevMember
        'removes'
      else
        'changes'
    trackUe('card detail', verb, 'member', 'on checkitem', '', 'by clicking a submit button in member picker')

  openMenu: (e) ->
    Util.stop(e)

    PopOver.toggle
      elem: e.target
      view: CheckItemMenuView
      options: { @model, @modelCache }
      keepEdits: true

  remove: ->
    unregisterShortcutHandler(@onShortcut)
    super

  edit: ->
    super

    board = @model.getBoard()
    product = board?.getOrganization()?.getProduct()
    orgIsHidden = board?.hasOrganization() && !board?.getOrganization()?

    @$('.js-assign,.js-due').toggleClass('hide', !shouldShowEditModeButtons(product, true, !orgIsHidden))
    @renderEditItemButtons()

  renderEditItemButtons: ->
    $editControls = @$('.edit-controls')
    if $editControls.length
      idMember = @model.get('idMember')
      due = @model.get('due')

      fullName = idMember && @modelCache.get('Member', idMember)?.get('fullName')
      $editControls.find('.js-assign').html(editAssignTemplate(fullName))

      dueText = due && Dates.toDateString(due)
      $editControls.find('.js-due').html(editDueTemplate(dueText))

    @
